import { render, staticRenderFns } from "./pbx2prop.vue?vue&type=template&id=27e53491"
import script from "./pbx2prop.vue?vue&type=script&lang=js"
export * from "./pbx2prop.vue?vue&type=script&lang=js"
import style0 from "./pbx2prop.vue?vue&type=style&index=0&id=27e53491&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports